import { render, staticRenderFns } from "./VerticalSelect.html?vue&type=template&id=d71edf72&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalSelect.scss?vue&type=style&index=0&id=d71edf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71edf72",
  null
  
)

export default component.exports